import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-the-header-navi-on-general__navi--usermenu" }
const _hoisted_2 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_3 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_4 = {
  key: 0,
  class: "p-the-header-navi-on-general__navi__item"
}
const _hoisted_5 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_6 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_7 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_8 = { class: "p-the-header-navi-on-general__navi__item" }
const _hoisted_9 = { class: "p-the-header-navi-on-general__navi__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconHumanWithOutline = _resolveComponent("IconHumanWithOutline")!
  const _component_IconBase = _resolveComponent("IconBase")!
  const _component_NaviItemLinkForSpOnGeneral = _resolveComponent("NaviItemLinkForSpOnGeneral")!
  const _component_IconPointDefault = _resolveComponent("IconPointDefault")!
  const _component_IconThanksMessage = _resolveComponent("IconThanksMessage")!
  const _component_IconNotification = _resolveComponent("IconNotification")!
  const _component_IconOrderHistory = _resolveComponent("IconOrderHistory")!
  const _component_IconHistoryLog = _resolveComponent("IconHistoryLog")!
  const _component_IconHeart = _resolveComponent("IconHeart")!
  const _component_IconMail = _resolveComponent("IconMail")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    _createElementVNode("li", _hoisted_2, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: _ctx.urls.mypage,
        label: "マイページ"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24,
            "view-box": "0 0 24 24"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconHumanWithOutline)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["url"])
    ]),
    _createElementVNode("li", _hoisted_3, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: _ctx.urls.point_confirmation,
        label: "ポイント確認"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconPointDefault, {
            "icon-size": 24,
            "bg-color": _ctx.iconColor,
            "icon-color": "#ffffff",
            "border-color": _ctx.iconColor
          }, null, 8, ["bg-color", "border-color"])
        ]),
        _: 1
      }, 8, ["url"])
    ]),
    (_ctx.thanksFunctionEnabled && !_ctx.isGroupBudget)
      ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
          _createVNode(_component_NaviItemLinkForSpOnGeneral, {
            url: _ctx.urls.thanks_point,
            label: _ctx.thanksPointName + 'メッセージ',
            "notification-count": _ctx.thanksPointUnread
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24",
                "icon-color": _ctx.iconColor
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconThanksMessage)
                ]),
                _: 1
              }, 8, ["icon-color"])
            ]),
            _: 1
          }, 8, ["url", "label", "notification-count"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("li", _hoisted_5, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: _ctx.urls.whats_new,
        label: "お知らせ",
        "notification-count": _ctx.whatsNewUnread
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24,
            "view-box": "0 0 24 24",
            "icon-color": _ctx.iconColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconNotification)
            ]),
            _: 1
          }, 8, ["icon-color"])
        ]),
        _: 1
      }, 8, ["url", "notification-count"])
    ]),
    _createElementVNode("li", _hoisted_6, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: _ctx.urls.orders,
        label: "申込履歴"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24,
            "view-box": "0 0 24 24",
            "icon-color": _ctx.iconColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconOrderHistory)
            ]),
            _: 1
          }, 8, ["icon-color"])
        ]),
        _: 1
      }, 8, ["url"])
    ]),
    _createElementVNode("li", _hoisted_7, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: _ctx.urls.visit,
        label: "閲覧履歴"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24,
            "view-box": "0 0 24 24",
            "icon-color": _ctx.iconColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconHistoryLog)
            ]),
            _: 1
          }, 8, ["icon-color"])
        ]),
        _: 1
      }, 8, ["url"])
    ]),
    _createElementVNode("li", _hoisted_8, [
      _createVNode(_component_NaviItemLinkForSpOnGeneral, {
        url: _ctx.urls.favorites,
        label: "お気に入り"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_IconBase, {
            width: 24,
            height: 24,
            "view-box": "0 0 24 24",
            "icon-color": _ctx.iconColor
          }, {
            default: _withCtx(() => [
              _createVNode(_component_IconHeart)
            ]),
            _: 1
          }, 8, ["icon-color"])
        ]),
        _: 1
      }, 8, ["url"])
    ]),
    _createElementVNode("li", _hoisted_9, [
      (!_ctx.showMailSettings && !_ctx.isGroupBudget)
        ? (_openBlock(), _createBlock(_component_NaviItemLinkForSpOnGeneral, {
            key: 0,
            url: _ctx.urls.mail_settings,
            label: "メール受信設定"
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_IconBase, {
                width: 24,
                height: 24,
                "view-box": "0 0 24 24",
                "icon-color": "transparent"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_IconMail)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["url"]))
        : _createCommentVNode("", true)
    ])
  ]))
}